import React from 'react';

export default {
  width: 19,
  height: 16,
  content: (
    <path d="M5.975 16c7.17 0 11.092-6.156 11.092-11.495 0-.175 0-.349-.012-.522A8.098 8.098 0 0 0 19 1.892a7.569 7.569 0 0 1-2.239.635A4.032 4.032 0 0 0 18.475.293a7.648 7.648 0 0 1-2.475.98C14.79-.057 12.87-.383 11.316.48c-1.555.862-2.358 2.699-1.96 4.48C6.222 4.794 3.302 3.26 1.322.736.288 2.583.816 4.945 2.53 6.13A3.766 3.766 0 0 1 .76 5.624v.052c0 1.923 1.309 3.58 3.127 3.96a3.76 3.76 0 0 1-1.76.07c.51 1.645 1.974 2.772 3.642 2.805a7.649 7.649 0 0 1-4.841 1.733c-.31-.001-.62-.02-.928-.059a10.755 10.755 0 0 0 5.975 1.812" />
  )
};
